// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"Tabs_Tabs__20FDO","hundred":"Tabs_hundred__26Wsx","thoundson":"Tabs_thoundson__3RkgC","ten-thoundson":"Tabs_ten-thoundson__3J0JP","active":"Tabs_active__1zHHZ"};